import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppSettingsService } from '../AppSettingsService';

export const useCreateAppSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => AppSettingsService.createAppSetting(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['app-settings'] });
    },
  });
};

export const useUpdateAppSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ parameter, data }) =>
      AppSettingsService.updateAppSetting(parameter, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['app-settings'] });
    },
  });
};
